<template>
  <ReportWrapper
    :loading="false"
    :on-load="loadReport"
    :tab-lv1-index="tabLv1Index"
    :tab-lv2-index="tabLv2Index"
    :showProviderFilter="false"
  >
    <v-row class="tile-grid px-3 pb-3">
      <v-col
        v-for="(tile, i) in tiles"
        :key="i"
        cols="12"
        sm="6"
        md="4"
        lg="4"
        xl="3"
        class="tile-column"
      >
        <NumberTile
          :title="tile.title"
          :value="tile.value"
          :type="tile.type"
          :loading="loading"
        />
      </v-col>
    </v-row>
  </ReportWrapper>
</template>

<script>
import DataService from '../../../../_services/DataService';
import NumberTile from '../../../components/Reporting/NumberTile';
import ReportWrapper from '../../../components/Reporting/ReportWrapper';

export default {
  name: 'Reporting',
  components: { NumberTile, ReportWrapper },
  props: ['tabLv1Index', 'tabLv2Index'],
  data() {
    return {
      pageName: 'Reporting',
      tiles: [
        { title: 'Active Users', value: 0, type: 'number' },
        { title: 'Sessions', value: 0, type: 'number' },
        { title: 'New Users', value: 0, type: 'number' },
        { title: 'Appointments Scheduled via Acrew', value: 0, type: 'number' },
        { title: 'Production Value from Acrew', value: 0, type: 'currency' },
        { title: 'Payments made via Acrew', value: 0, type: 'number' },
        { title: 'Revenue from Acrew Payments', value: 0, type: 'currency' },
      ],
      loading: true,
    };
  },
  methods: {
    async loadReport(dateRange) {
      this.loading = true;

      const [productionResponse, auResponse, newUsersResponse, onlinePaymentResponse] = await Promise.all([
        DataService.getProductionReport(dateRange),
        DataService.getActiveUserReport(dateRange),
        DataService.getNewUserReport(dateRange),
        DataService.getOnlinePaymentReport(dateRange),
      ]);

      if (auResponse.status === 200) {
        this.tiles[0].value = auResponse.data.distinctUserCount;
        this.tiles[1].value = auResponse.data.totalSessionCount;
      }

      if (newUsersResponse.status === 200) {
        this.tiles[2].value = newUsersResponse.data;
      }

      if (productionResponse.status === 200) {
        this.tiles[3].value = productionResponse.data.appointmentsScheduled;
        this.tiles[4].value = productionResponse.data.totalBillableDollars;
      }

      if (onlinePaymentResponse.status === 200) {
        this.tiles[5].value = onlinePaymentResponse.data.transactionCount;
        this.tiles[6].value = onlinePaymentResponse.data.transactionRevenue;
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/mixins/_mobile-nav-spacing.scss';

.tile-grid {
  @include mobile-nav-spacing;
}

.tile-column {
  padding: 8px;
}
</style>
